import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

export const getLocationValidations = createEffect(({ id }: { id: number }) =>
  apiFetch(`/admin/site/${id}/validations/v2`),
);
